/**
 * Generate srcSet attribute for responsive images
 */
export function getImageSrcSet(
  thumbnailUrl: string | null,
  mediumUrl: string | null,
  fullUrl: string
): string {
  const sources: string[] = [];
  
  if (thumbnailUrl) {
    sources.push(`${thumbnailUrl} 400w`);
  }
  if (mediumUrl) {
    sources.push(`${mediumUrl} 800w`);
  }
  sources.push(`${fullUrl} 1920w`);
  
  return sources.join(", ");
}

/**
 * Get the best image URL based on intended display size
 */
export function getOptimalImageUrl(
  thumbnailUrl: string | null,
  mediumUrl: string | null,
  fullUrl: string,
  size: "thumbnail" | "medium" | "full"
): string {
  switch (size) {
    case "thumbnail":
      return thumbnailUrl || mediumUrl || fullUrl;
    case "medium":
      return mediumUrl || fullUrl;
    case "full":
    default:
      return fullUrl;
  }
}

/**
 * Default sizes attribute for responsive images
 */
export const DEFAULT_GRID_SIZES = "(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw";
export const LIGHTBOX_SIZES = "(max-width: 768px) 100vw, 80vw";
